import React, { useId } from 'react';
import '../../styles/pp-auth.css';

/**
 * The PopupPush mark (approved 2026-09-15): honey gradient tile, white screen,
 * honey play triangle, dark chip with two white lines. Geometry and colours are
 * copied from .claude/login-prototype.html.
 *
 * The intro animation lives in pp-auth.css under `.ppa .ppa-mark …`, so the
 * mark animates only inside the auth layout; in the sidebar / mobile navbar
 * (no `.ppa` ancestor) the very same SVG is static. prefers-reduced-motion is
 * handled in the stylesheet.
 */
export default function LogoMark({ size = 56, className = '', title = 'PopupPush', style }) {
  const gid = useId().replace(/:/g, '');
  return (
    <svg
      className={`ppa-mark ppa-mark-svg ${className}`.trim()}
      width={size}
      height={size}
      viewBox="0 0 64 64"
      role="img"
      aria-label={title}
      style={style}
    >
      <defs>
        <linearGradient id={`ppa-g-${gid}`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#E9A23E" />
          <stop offset="1" stopColor="#B9701C" />
        </linearGradient>
      </defs>
      <rect className="ppa-tile" width="64" height="64" rx="15" fill={`url(#ppa-g-${gid})`} />
      <rect className="ppa-screen" x="10" y="14" width="44" height="32" rx="6" fill="#fff" />
      <path className="ppa-play" d="M27 24.5 L39 31.5 L27 38.5 Z" fill="#B9701C" />
      <g className="ppa-chip">
        <rect x="34" y="34" width="20" height="16" rx="5" fill="#8A4E12" stroke="#fff" strokeWidth="1.5" />
        <rect x="38" y="39" width="12" height="2.6" rx="1.3" fill="#fff" />
        <rect x="38" y="43.5" width="8" height="2.6" rx="1.3" fill="#fff" opacity=".7" />
      </g>
    </svg>
  );
}
